import DataVScrollRankingBoard from './scroll-ranking-board';
export default DataVScrollRankingBoard;
